// Auth routes
export const FORGETPASS = "/forget-password";
export const LOGIN_PAGE = "/login";

// Public routes
export const DASHBOARD = "/dashboard";
export const INIT = "/";
export const PROFILE = "/profile";

// Utility routes
export const NOT_FOUND = "/ruta-no-encontrada";
export const UNATHORIZED = "/acceso-no-autorizado";

// Maintenance routes
// export const MAINTENANCE_PAGES_LIST = "/mantenimientos/paginas/listado";

export const EMP_EMPLOYEETYPE_LIST = "/mantenimientos/tipos-empleados/listado";
export const MAINTENANCE_ACTIONS_LIST = "/mantenimientos/acciones/listado";
export const MAINTENANCE_AREA_LIST = "/mantenimientos/areas/listado";
export const MAINTENANCE_MENU_GROUPS_LIST = "/mantenimientos/grupos-menu/listado";
export const MAINTENANCE_MENU_OPTIONS_LIST = "/mantenimientos/opciones-menu/listado";
export const MAINTENANCE_MENUS_LIST = "/mantenimientos/menus/listado";
export const MAINTENANCE_PAGES_LIST = "/mantenimientos/paginas/listado";
export const MAINTENANCE_ROLES_LIST = "/mantenimientos/roles/listado";
export const MAINTENANCE_TABLE_LIST = "/mantenimientos/mesas/listado";
export const MAINTENANCE_COMMANDS_LIST = "/mantenimientos/comandas/listado";
export const MAINTENANCE_USER_TYPES_LIST = "/mantenimientos/tipos-usuario/listado";
export const MAINTENANCE_USERS_LIST = "/mantenimientos/usuarios/listado";
export const USR_FINGER_REASON_LIST = "/mantenimientos/razones-huellas/listado";
export const USR_SUPERVISOR_PERMISSION_LIST = "/mantenimientos/permisos-supervisores/listado";
export const USR_USER_AH_LIST = "/mantenimientos/usuarios-ahs/listado";
export const USR_SPECIAL_ACCESS_USER_LIST =
  "/mantenimientos/usuarios-especiales/listado";
export const USR_DUALPAYMENTS_COMPANY_LIST =
  "/mantenimientos/dualpayments-companias/listado";
export const USR_DUALPAYMENTS_COMPANY_DETAIL =
  "/mantenimientos/dualpayments-companias/detalle/:companyid";

// Prices
export const PRC_BANK_ACCOUNT_LIST = "/empresa/cuentas-bancos/listado";
export const PRC_BANK_DEPOSIT_LIST = "/empresa/depositos-bancarios/listado";
export const PRC_BANK_LIST = "/precios/bancos/listado";
export const PRC_BIN_LIST = "/precios/bines/listado";
export const PRC_GIFT_CARD_LIST = "/precios/gift-cards/listado";
export const PRC_PAYMENT_METHOD_GROUP_LIST = "/precios/grupos-metodos-pago/listado";
export const PRC_PAYMENT_METHOD_LIST = "/precios/metodos-pago/listado";
export const PRC_PRICE_GROUP_LIST = "/precios/grupos-precio/listado";
export const PRC_TERM_BC_LIST = "/precios/terminos-bc/listado";
export const PRC_VENDOR_BANK_ACCOUNT_LIST ="/proveedores/cuentas-bancos/listado";
export const PRC_VOUCHER_LIST = "/precios/vouchers/listado";
export const PRC_VOUCHERTYPE_LIST = "/precios/vouchers-type/listado";

// General
export const BUS_CURRENCY_LIST = "/general/monedas/listado";
export const BUS_SERIE_LIST = "/general/series/listado";
export const GEN_ATTRIBUTE_LIST = "/general/atributos/listado";
export const GEN_PAYMENT_TERM_LIST = "/general/terminos-pago/listado";
export const PRO_VENDOR_POSTING_GROUP_LIST = "/general/grupos-posteo-proveedores/listado";
export const TIME_MEASUREMENT_LIST = "/general/periodos-tiempo/listado";

// Configurations
export const CFG_CASH_DECLARATION_LIST = "/configuraciones/declaraciones-dinero/listado";
export const CFG_CONFIGURATION_COMISION_LIST ="/configuraciones/comisiones/listado";
export const CFG_CONFIGURATION_LIST = "/configuraciones/configuraciones/listado";
export const CFG_CONFIGURATIONPRINTCOPIES_LIST = "/configuraciones/impresiones";
export const CFG_MODULE_LIST = "/configuraciones/modulos/listado";
export const CFG_SERIE_SETUP_LIST = "/configuraciones/configuracion-series/listado";
export const INF_INFO_CODE_LIST = "/configuraciones/info-codes/listado";
export const INV_CREATE_LIST = "/inventario/tiendas/listado";
export const INV_MOV_TYPE_LIST = "/inventario/tipos-movimientos/listado";
export const LOC_CITY_LIST = "/general/ciudades/listado";
export const LOC_COUNTRY_LIST = "/general/paises/listado";
export const LOC_STATE_LIST = "/general/departamentos/listado";

// Accounting
export const ACC_DAILY_INVOICES_REPORT_LIST = "/contabilidad/reporte-facturas-diarias/listado";
export const ACC_ENTRIES = "/contabilidad/asientos-contables/listado";
export const ACC_EXPENSES_LIST = "/contabilidad/gastos/listado";
export const ACC_EXPENSES_PAYMENT_LIST = "/contabilidad/facturas/gastos/pagos/listado";
export const ACC_INVOICES_LIST = "/contabilidad/facturas/listado";
export const ACC_INVOICES_REPORT_LIST = "/contabilidad/reporte-facturas/listado";
export const ACC_INVOICESXEMPLOYEE_GRUOPEDREPORT_LIST = "/contabilidad/facturas/empleados/agrupado/listado";
export const ACC_INVOICESXEMPLOYEE_REPORT_LIST = "/contabilidad/facturas/empleados/listado";
export const ACC_JOURNAL_LIST = "/contabilidad/libros-contables/listado";
export const ACC_MANUAL_MOVEMENTS = "/contabilidad/asientos-contables/manuales/listado";
export const ACC_OVERDUE_CUSTOMER_INVOICES_LIST = "/contabilidad/facturas-vencidas/clientes/listado";
export const ACC_OVERDUE_VENDOR_INVOICES_LIST = "/contabilidad/facturas-vencidas/partners/listado";
export const ACC_QUOTATION_INVOICES_LIST = "/contabilidad/facturas/clientes/listado";
export const ACC_QUOTATION_PAYMENT_INVOICES_LIST = "/contabilidad/facturas/clientes/pagos/listado";
export const ACC_STATUS_RESULT_REPORT_LIST = "/contabilidad/reporte-estado-resultados/listado";
export const ACC_VENDOR_PAYMENT_INVOICES_LIST = "/contabilidad/facturas/proveedores/pagos/listado";
export const ERP_CREDIT_NOTES_LIST = "/contabilidad/notas-credito/erp/listado";
export const ERP_CREDIT_NOTES_REPORT_LIST = "/contabilidad/reportes/notas-credito/listado";
export const INVOICE_TYPES_LIST = "/contabilidad/tipos-facturas/listado";
export const POS_CLOSURE_REPORT_LIST = "/contabilidad/reporte-cierre/listado";

// Stores
export const EMP_EMPLOYEE_LIST = "/tiendas/empleados/listado";
export const SAL_SALE_LIST = "/tiendas/transacciones/listado";
export const SAL_SALESTATUS_LIST = "/tiendas/estado-transacciones/listado";
export const STO_ACCOUNT_SUBCATEGORY_LIST = "/tiendas/cuentas-subcategorias/listado";
export const STO_COMPANY_LIST = "/companias/listado";
export const STO_INCOME_EXPENSE_ACCOUNT_LIST ="/tiendas/cuentas-ingresos-gastos/listado";
export const STO_LEDGER_ACCOUNT_LIST = "/tiendas/cuentas-contables/listado";
export const STO_SERVICE_CATEGORY_LIST = "/tiendas/service-category/listado";
export const STO_STORE_LIST = "/tiendas/tiendas/listado";
export const STO_TRANSACTION_TYPE_LIST = "/tiendas/transaction-type/listado";
export const STO_WAREHOUSE_LIST = "/tiendas/bodegas/listado";

//POS
export const INV_PRINT_REASON = "/pos/razones-impresion/listado";
export const POS_MENU_PRODUCT_LIST = "/pos/menu-productos/listado";
export const POS_TERMINAL_LIST = "/pos/terminales/listado";
export const POS_PRINTER_LIST = "/pos/impresoras/listado";
export const SAL_SALE_RETURN_REASON = "/pos/motivos-devolucion/listado";

// Company
export const CMP_ATTRIBUTE_VALUE_LIST = "/empresas/valores-atributos/listado";

// Customers
export const CUS_BUS_POSTING_GROUP_LIST = "/clientes/grupo-contable-negocio/listado";
export const CUS_CUSTOMER_LIST = "/clientes/clientes/listado";
export const CUS_CUSTOMER_MEMBER_CLUB_LIST = "/clientes/clubes-cliente/listado";
export const CUS_GROUP_LIST = "/clientes/grupos/listado";
export const CUS_MEMBER_CLUB_CARD_SPOOL_LIST = "/clientes/tarjetas-clubes/listado";
export const CUS_MEMBER_CLUB_LIST = "/clientes/clubes/listado";
export const CUS_MEMBER_CLUB_SCHEME_LIST = "/clientes/esquemas-clubes/listado";
export const CUS_POSTING_GROUP_LIST = "/clientes/grupo-contable-cliente/listado";

// Products
export const INV_AVAILABLE_PRODUCTS_LIST = "/productos/inventario-disponible/listado";
export const INV_MOVEMENTS_PRODUCTS_LIST = "/productos/inventario-movimientos/listado";
export const INV_VALORIZATION_PRODUCTS_LIST = "/productos/inventario-valorizacion/listado";
export const INV_WAREHOUSE_TRANSFER_LIST = "/productos/transferencia-bodegas/listado";
export const MODIFIER_GROUP_LIST =  "/productos/grupo-modificadores/listado";
export const PRO_ASSORTMENT_TREE_LIST = "/productos/arbol-surtido/listado";
export const PRO_BASE_UNIT_MEASURE_LIST = "/productos/unidades-medida-base/listado";
export const PRO_BILL_LADING_LIST = "/productos/contenedores-importacion/listado";
export const PRO_BRAND_LIST = "/productos/marcas/listado";
export const PRO_CATEGORY_LIST = "/productos/categorias/listado";
export const PRO_DIVISION_LIST = "/productos/divisiones/listado";
export const PRO_GROUP_LIST = "/productos/grupos/listado";
export const PRO_IMPORT_COST_LIST = "/productos/gastos-importacion/listado";
export const PRO_INVENTORY_GROUP_LIST = "/productos/grupos-inventario/listado";
export const PRO_IVA_LIST = "/productos/ivas/listado";
export const PRO_IVA_POSTING_GROUP_LIST = "/productos/grupos-registro-iva/listado";
export const PRO_MINMAX_ALERT_LIST = "/productos/alertas/listado";
export const PRO_PRODUCT_CONTRIBUTION_MARGIN_LIST = "/productos/margen-contribucion/listado";
export const PRO_PRODUCT_LIST = "/productos/productos/listado";
export const PRO_PURCHASE_RECEIPT_LIST = "/productos/recepcion-producto/listado";
export const PRO_PURCHASE_REQUEST_LIST ="/productos/solicitudes-compra/listado";
export const PRO_QUOTATION_LIST = "/clientes/cotizaciones/listado";
export const PRO_REQUISITION_LIST = "/productos/requisicion-producto/listado";
export const PRO_SPECIAL_GROUP_LIST = "/productos/grupos-especiales/listado";
export const PRO_TYPE_LIST = "/productos/tipos/listado";
export const PRO_VENDOR_LIST = "/productos/proveedores/listado";
export const PRO_WARRANTY_FORMAT_LIST = "/productos/formatos-garantia/listado";
export const PRO_WARRANTY_LIST = "/productos/garantias/listado";
export const PRO_WARRANTY_MODEL_LIST = "/productos/modelos-garantia/listado";
export const PRO_WARRANTY_TREE_LIST = "/productos/arboles-garantia/listado";
export const UPLOAD_INVENTORY_ADJUSTMENT_LIST ="/productos/ajuste-inventario/listado";
export const UPLOAD_INVENTORY_LIST = "/productos/subir-inventario/listado";

// Ofertas
export const OFF_COUPON_ISSUER_LIST = "/ofertas/emisores-cupones/listado";
export const OFF_COUPON_LIST = "/ofertas/cupones/listado";
export const OFF_EMPLOYEE_DISCOUNT_LIST = "/ofertas/descuentos-empleado/listado";
export const OFF_MIX_AND_MATCH_LIST = "/ofertas/mezclas-combinaciones/listado";
export const OFF_OFFER_LIST = "/ofertas/ofertas/listado";
export const OFF_OFFER_ON_DISCOUNT_LIST = "/ofertas/ofertas-sobre-descuentos/listado";
export const OFF_OFFER_PRIORITY_LIST = "/ofertas/prioridades/listado";
export const OFF_VALIDATION_PERIOD_LIST = "/ofertas/periodos-validacion/listado";

// Reportes
export const RPT_CASH_RECEIPT_REPORT = "/reportes/arqueo";
export const RPT_PRODUCTS_SALES_REPORT = "/reportes/ventas-producto/listado";
export const RPT_SALES_BY_CUSTOMER_REPORT = "/reportes/ventas-cliente-listado";

// Configuraciones
export const CONFIGURATION_MENU_LIST = "/general/menu/configuraciones";

//Doc
export const DOC_FORMAT_LIST = "/general/formatos/listado";

//Tipos de Departamentos
export const GOR_DEPARMENT_TYPE_LIST = "/recursoshumanos/tipos-departamentos/listado";

//Tipos de Puestos
export const GOR_WORK_POSITION_TYPE_LIST = "/recursoshumanos/tipos-puestos/listado";

//Areas
export const GOR_WORK_AREA_LIST = "/recursoshumanos/areas/listado";

//Departamentos
export const GOR_DEPARTMENT_LIST = "/recursoshumanos/departamentos/listado";

//Puestos
export const GOR_WORK_POSITION_LIST = "/recursoshumanos/puestos/listado";

//Centros de Costo
export const GOR_COST_CENTER_LIST = "/recursoshumanos/centros-costo/listado";

//Posiciones
export const GOR_POSITION_LIST = "/recursoshumanos/posiciones/listado";

//Categorías de Retiro
export const GEX_TERMINATION_CATEGORY_LIST = "/recursoshumanos/categorias-retiro/listado";
//Motivos de Retiro
export const GEX_TERMINATION_REASON_LIST = "/recursoshumanos/motivos-retiro/listado";
//Tipos de Contrato
export const GEX_CONTRACT_TYPE_LIST = "/recursoshumanos/tipos-contrato/listado";

//Tipos de Documento
export const GEX_DOCUMENT_TYPE_LIST = "/recursoshumanos/tipos-documento/listado";

//Tipos de Parentesco
export const GEX_PARENT_TYPE_LIST = "/recursoshumanos/tipos-parentesco/listado";

//Expedientes
export const GEX_INFO_EMPLOYEE_LIST = "/recursoshumanos/colaboradores/listado";

//Tipos de Aportaciones
export const GEX_CONTRIBUTION_TYPE_LIST = "/recursoshumanos/tipos-aportacion/listado";

//Aportaciones
export const GEX_ACCOUNT_TYPE_LIST = "/recursoshumanos/tipos-cuenta/listado";
export const GEX_CONTRIBUTION_EMPLOYEE_LIST = "/recursoshumanos/aportacion-empleados/listado";
export const GEX_PAYMENT_METHOD_LIST = "/recursoshumanos/metodos-pago/listado";

export const NotAuthRoutes = [
  DASHBOARD,
  FORGETPASS,
  INIT,
  LOGIN_PAGE,
  NOT_FOUND,
  PROFILE,
  UNATHORIZED,
];

//CrediDiunsa
export const OFF_OFFER_ON_DISCOUNT_CONFIGS_LIST =
  "/credidiunsa/descuento-adicional/listado";
